//     public static class Spring
//     {
//         public const float DefaultDampingRatio = 0.5f;
//         public const float DefaultResponse = 0.35f;

//         public const float HighBouncy = 0.4f;
//         public const float LowBouncy = 0.75f;
//         public const float NoBouncy = 1.0f;

//         public const float FastestResponse = 0.2f;
//         public const float FasterResponse = 0.25f;
//         public const float FastResponse = 0.3f;
//         public const float SlowResponse = 0.7f;
//         public const float SlowerResponse = 1.0f;
// }

export class SpringParameters {
    #dampingRatio: number;
    #response: number;
    #stiffness: number;
    #damping: number;

    constructor(dampingRatio: number, response: number) {
        dampingRatio = Math.min(Math.max(dampingRatio, 0.1), 1.0);
        response = Math.min(Math.max(response, 0.2), 2.0);

        const r = (2.0 * Math.PI) / response;
        this.#dampingRatio = dampingRatio;
        this.#response = response;
        this.#stiffness = r * r;
        this.#damping = (4.0 * Math.PI * dampingRatio) / response;
    }

    get dampingRatio() { return this.#dampingRatio; }
    get response() { return this.#response; }
    get stiffness() { return this.#stiffness; }

    withDampingRatio(value: number) {
        return new SpringParameters(value, this.#response);
    }

    withResponse(value: number) {
        return new SpringParameters(this.#dampingRatio, value);
    }

    calculateForce(current: number, target: number, velocity: number) {
        return (-this.#stiffness * (current - target)) - (velocity * this.#damping);
    }
}
